
import Chat from './components/Chat';
import { UsersProvider } from './context/usersContext';

function App() {
  return (
    <UsersProvider>
      <Chat />
    </UsersProvider>
  );
}

export default App;
